import { Component } from '@angular/core';
import { MatCardTitle } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { EmailService } from '../../services/email/email.service';

interface Contato {
  nome: string;
  email: string;
  mensagem: string;
}

@Component({
  selector: 'app-contato',
  standalone: true,
  imports: [
    MatCardTitle,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    FormsModule,
  ],
  templateUrl: './contato.component.html',
  styleUrl: './contato.component.scss',
})
export class ContatoComponent {

  enviarDesabilitado = false;

  contato: Contato = {
    nome: '',
    email: '',
    mensagem: '',
  };

  constructor(
    private toastr: ToastrService,
    private emailService: EmailService
  ) {}

  enviarMensagem() {

    this.enviarDesabilitado = true;

    if (!this.contato.nome || !this.contato.email || !this.contato.mensagem) {
      this.toastr.error('Todos os campos devem ser informados!', 'Atenção!');
      this.enviarDesabilitado = false;
      return;
    }
    this.emailService.enviarEmail(
      {
        nome: this.contato.nome,
        remetente: this.contato.email,
        mensagem: this.contato.mensagem
      }
    ).then(()=>{
      this.toastr.success('Mensagem enviada com sucesso', 'Sucesso!');
    }).catch(()=>{
      this.toastr.error('Ocorreu um erro ao enviar o email!', 'Erro!');
    }).finally(()=>{
      this.enviarDesabilitado = false
    })
  }
}
